import theme from '@/common/styles/mui-theme';

const financialDetailsStyles = {
  body: {
    px: 6,
    pb: 6,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 4,
    height: 'calc(100% - 88px)',
  },
  pageHeader: {
    display: 'flex',
    p: 6,
  },
  section: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px',
    backgroundColor: theme.palette.common.white,
    p: 6,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    mb: 6,
  },
  sectionTitle: {
    ...theme.typography.h5,
    fontSize: '24px',
    color: theme.palette.text.primary,
  },
  dataGridWrap: {
    width: '100%',
  },
  emptyState: {
    minHeight: 198,
    justifyContent: 'center',
    gap: 4,
  },
  emptyStateText: {
    ...theme.typography.h5,
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
  button: {
    minWidth: 0,
  },
  notFound: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px',
    backgroundColor: theme.palette.common.white,
    p: 6,
    ...theme.typography.body1,
    color: theme.palette.text.secondary,
  },
};

export default financialDetailsStyles;
